import {JobNodes} from "@cm/job-nodes/job-nodes"
import {RenderOutputForPassName} from "@cm/job-nodes/rendering"

export function combinedPassFromRenderTask(renderTask: JobNodes.TypedDataNode<RenderOutputForPassName<"Combined">>) {
    return JobNodes.get(JobNodes.get(renderTask, "renderPasses"), "Combined")
}
